export default __webpack_public_path__ + "locales/lo-LA/PeopleTranslations.json?hash=4ecdd8595a48b6a9739c59a4e38a277a";